module.exports = __webpack_public_path__ + "static/img/90-060fabe2.c10.c6f1fc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/rowdy-coyote/90-060fabe2.c10.jpg
// module id = 7zbK
// module chunks = 2